"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPixelsMessage = void 0;
class SetPixelsMessage {
    constructor() {
        this.palette = [];
        this.pixelValues = [];
    }
    static fromPixelValueCollection(values) {
        var _a, _b;
        const defaultColor = "#FFFFFF";
        const allUsedPixelColors = values.map(pixel => { var _a; return (_a = pixel.color) !== null && _a !== void 0 ? _a : defaultColor; });
        const palette = [...new Set(allUsedPixelColors)];
        const protoMessage = new SetPixelsMessage();
        protoMessage.palette = palette;
        protoMessage.pixelValues = [];
        for (let pixel of values) {
            const x = pixel.x;
            const y = (_a = pixel.y) !== null && _a !== void 0 ? _a : 0;
            const color = (_b = pixel.color) !== null && _b !== void 0 ? _b : defaultColor;
            const paletteRef = palette.indexOf(pixel.color);
            protoMessage.pixelValues.push({ x, y, color, paletteRef });
        }
        return protoMessage;
    }
}
exports.SetPixelsMessage = SetPixelsMessage;
//# sourceMappingURL=SetPixelsMessage.js.map